import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import { GET_SHOPPING_BUNDLE } from "~/clientState/providers/operations/shoppingBundle";
import type {
  GetShoppingBundleQuery,
  GetShoppingBundleQueryVariables,
  ShoppingBundleRequest,
} from "~/generated/graphql";
import { useShoppingInfo } from "./useShoppingInfo";
import { useSkipGetShoppingBundle } from "../providers/generic/SkipGetShoppingBundle";

const useShoppingBundleQuery = (): UseQueryResult<
  GetShoppingBundleQuery,
  GetShoppingBundleQueryVariables
> => {
  const skip = useSkipGetShoppingBundle();
  const shoppingInfo = useShoppingInfo();
  const request: ShoppingBundleRequest = {
    shoppingInfo,
  };

  return useQuery<GetShoppingBundleQuery, GetShoppingBundleQueryVariables>(
    GET_SHOPPING_BUNDLE,
    {
      variables: {
        request,
      },
      skip,
    },
  );
};

export default useShoppingBundleQuery;
